import { render, staticRenderFns } from "./SourcePasswordSetupModal.vue?vue&type=template&id=59d545a6&"
import script from "./SourcePasswordSetupModal.vue?vue&type=script&lang=ts&"
export * from "./SourcePasswordSetupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports